import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Dashboard } from 'views/dashboard/Dashboard';
import { InvitationsView } from 'views/add-organization/inviteUsers';
import Project from 'views/project-page/table/ProjectTable';
import ProjectCreationFlow from 'views/project-creation/ProjectCreationFlow';
import AddGeodata from 'views/add-geodata/AddGeodata';
import AddSimulation from 'views/add-simulation/AddSimulation';
import Records from 'views/project-page/observation_reports/Records';
import ProjectReview from 'views/dashboard/ProjectReview';
import GridReview from 'views/add-grid/GridReview';
import GeodataReview from 'views/add-geodata/GeodataReview';
import SimulationReview from 'views/add-simulation/SimulationReview';

const LegacyAddGridRedirect = () => {
  const { projectId } = useParams();
  return React.createElement(Navigate, {
    to: `/projects/add?step=grid&projectId=${projectId ?? ''}`,
    replace: true,
  });
};

const Routes = [
  {
    path: '/',
    view: Dashboard,
    layout: 'app',
    permission: 'viewer',
    title: 'Dashboard',
  },
  {
    path: '/dashboard',
    view: Dashboard,
    layout: 'app',
    permission: 'viewer',
    title: 'Dashboard',
  },
  {
    path: '/invitations',
    view: InvitationsView,
    layout: 'onboarding',
    permission: 'owner',
    title: 'Invitations',
  },
  {
    path: '/projects/:projectId',
    view: Project,
    layout: 'app',
    permission: 'viewer',
    title: 'Project',
  },
  {
    path: '/projects/:projectId/review',
    view: ProjectReview,
    layout: 'app',
    permission: 'viewer',
    title: 'Project Review',
  },
  {
    path: '/projects/add',
    view: ProjectCreationFlow,
    layout: 'app',
    permission: 'admin',
    title: 'Add Project',
  },
  {
    path: '/grids/add/:projectId',
    view: LegacyAddGridRedirect,
    layout: 'app',
    permission: ['editor', 'support'],
    title: 'Add Grid',
  },
  {
    path: '/grids/:gridId/review',
    view: GridReview,
    layout: 'app',
    permission: ['editor', 'support'],
    title: 'Grid Review',
  },
  {
    path: '/geodatas/add/:gridId',
    view: AddGeodata,
    layout: 'app',
    permission: ['editor', 'support'],
    title: 'Add Geodata',
  },
  {
    path: '/geodatas/:geodataId/review',
    view: GeodataReview,
    layout: 'app',
    permission: ['editor', 'support'],
    title: 'Geodata Review',
  },
  {
    path: '/simulations/add/:geodataId',
    view: AddSimulation,
    layout: 'app',
    permission: ['editor', 'support'],
    title: 'Add Simulation',
  },
  {
    path: '/simulations/:simulationId/review',
    view: SimulationReview,
    layout: 'app',
    permission: ['editor', 'support'],
    title: 'Simulation Review',
  },
  {
    path: '/projects/:projectId/observations',
    view: Records,
    layout: 'app',
    permission: 'viewer',
    title: 'Observation Reports',
  },
];

export default Routes;
